export default __webpack_public_path__ + "static/media/ISWEC-12-13.27bf08e0.pdf";